import axios from 'axios'
import store from '@/store'
import router from "@/router";
import {toast} from "../class/Notification";
import {findObjectIndex} from "../class/Converter";

const languageDataShape = (form) => {
    let formData = new FormData();
    formData.append('name', form.name);
    formData.append('type', form.type);
    formData.append('slug', form.slug);
    return formData;
}

export default {
    namespaced: true,
    state: {
        languages: [],
    },
    mutations: {
        setLanguages(state, languages) {
            state.languages = languages
        },
        setPanels(state, panels) {
            state.panels = panels
        },
        deleteLanguage: (state, language) => {
            state.languages.splice(findObjectIndex(store.getters['Language/getLanguages'], language), 1)
        },
    },
    actions: {
        getLanguages({commit}) {
            let request = axios.get(`/language`);

            request.then(res => {
                const data = res.data.data;
                commit('setLanguages', data)
            })
                .catch(error => {
                    console.log(error)
                })
            return request
        },
        deleteLanguage({commit}, form) {
            axios.delete(`/language/${form.id}`)
                .then(res => {
                    const language = res.data.data;
                    commit('deleteLanguage', language)
                })
                .catch(error => {
                    console.log(error)
                })
        },
        createLanguage({commit}, form) {
            const image = form.image;
            form = languageDataShape(form)
            form.append('image', image);
            axios.post('/language', form)
                .then(res => {
                    toast('عملیات با موفقیت انجام شد', 'زبان با موفقیت ثبت شد.')
                    store.dispatch('Language/getLanguages')
                })
                .catch(error => {
                    console.log(error)
                })
        },
        updateLanguage({commit}, form) {

            const languageId = form.id
            const image = form.image
            if (form.image !== undefined) {
                if (form.image.length !== 0) {
                    form = languageDataShape(form)
                    form.append('image', image);
                    form.append('_method', 'PUT')
                } else {
                    form = languageDataShape(form)
                    form.append('_method', 'PUT')
                }
            }

            axios.post(`/language/${languageId}`, form)
                .then(res => {
                    toast('عملیات با موفقیت انجام شد', 'زبان با موفقیت به روز رسانی شد.')
                    store.dispatch('Language/getLanguages')
                })
                .catch(error => {
                    console.log(error)
                })
        },
    },
    getters: {
        getLanguages: state => state.languages,
        getPanels: state => state.languages.filter(item => item.type === 1),
    }
}